import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import JoditEditor from "jodit-react";
const ReactQuillEditor = ({ label, mandatory, onChange, value }) => {
  return (
    <>
      <Stack
        direction="column"
        className="modal-stack"
        style={{ justifyContent: "flex-start", alignItems: "flex-start" }}>
        {label ? (
          <InputLabel required={mandatory} className="flex-2" style={{ marginBottom: "10px" }}>
            {label}
          </InputLabel>
        ) : null}
        <JoditEditor
          // ref={editor}
          value={value}
          onChange={(e) => {
            onChange(e);
          }}
          // className=\
        />
        <Stack sx={{ flex: 6, width: 100 }}>
          {/* <ReactQuill
            theme="snow"
            modules={modules}
            value={value || ""}
            onChange={onEditorStateChange}
          /> */}

          {/* <Editor
            editorState={editorState}
            wrapperClassName="demo-wrapper"
            editorClassName="demo-editor"
            onEditorStateChange={onEditorStateChange}
            mention={mention}
          /> */}
        </Stack>
      </Stack>
    </>
  );
};

export default ReactQuillEditor;
